export const multiselect = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}",
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}",
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}",
    },
  },
  dropdown: {
    width: "2.5rem",
    color: "{form.field.icon.color}",
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}",
    },
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}",
    gap: "0.5rem",
  },
  optionGroup: {
    background: "{list.option.group.background}",
    color: "{list.option.group.color}",
    fontWeight: "{list.option.group.font.weight}",
    padding: "{list.option.group.padding}",
  },
  clearIcon: {
    color: "{form.field.icon.color}",
  },
  chip: {
    borderRadius: "{chip.border.radius}",
  },
  emptyMessage: {
    padding: "{list.option.padding}",
  },
  extend: {
    ui: {
      fontLeading: "{form.field.font.leading}",
    },
  },
  css: ({ dt }: any): string => `
    .p-multiselect {
      line-height: ${dt("multiselect.ui.font.leading")};
    }

    .p-multiselect-fluid {
      width: 100%
    }

    .p-multiselect-label:has(.p-chip) {
      padding: 0;
    }

    .p-multiselect-display-chip .p-multiselect-label {
      gap: calc(${dt("multiselect.padding.y")} / 2);
    }

    .p-multiselect-display-chip .p-multiselect-label-empty,
    .p-multiselect-display-chip .p-multiselect-label:not(:has(.p-multiselect-chip-item)) {
      padding-top: calc(${dt("multiselect.padding.y")} / 2);
      padding-bottom: calc(${dt("multiselect.padding.y")} / 2);
    }

    .p-multiselect.overlay-only {
      border: none !important;

      .p-multiselect-dropdown,
      .p-multiselect-label-container {
        display: none !important;
      }
    }
  `,
};
